export default {
  routerBase: {
    'install': '設置',
    'homepage': '首頁',
    'statistics': '統計',
    'history': '歷史',
    'starttest': '開始測量',
    'data': '數據',
    'myfamily': '我的家人',
    'family': '家人',
    'setting': '設置',
    'personal': '個人',
    'consultation': '諮詢',
    'measurement': '測量結果',
    'improveprofile': '完善個人資料',
    'changephone': '更換手機號',
    'information': '資訊',
    'health report': '健康報告',
    'healthwarning': '健康預警',
    'healthadvice': '健康建議',
    'pressure': '血壓',
    'sugar': '血糖',
    'heartrate': '心率',
    'oxygen': '血氧',
    'step': '步數',
    'hrv': 'HRV心臟指數',
    'apnea': '呼吸暫停次數',
    'description': '商品詳情',
    'submitorder': '提交訂單',
    'orderlist': '訂單列表',
    'personaldetails': '個人信息',
    'mdi': '手動輸入',
    'record': '登錄',
    'help': '幫助中心',
    'downloadAPP': '下載蓋德健康APP',
    'associatedmobile': '關聯手機號',
    'privacypolicy': '《用戶服務協議及隱私政策條款》',
    'analysisreport ': '分析報告',
    'electrocardiogram': '查看心電圖',
    'directionforuse ': '使用說明',
    'privacypolicy ': '隱私政策',
    'addfamily': '添加家人',
    'bindaccount': '賬號綁定',
    'familyAdd': '新添家人',
    'register': '註冊',
    'putcode': '發送驗證碼'

  }
}
